#import "~/graphql/fragments/Components/CraftLink.graphql"
fragment IllustrationGrid on illustrationGridBlock_Entry {
    title: blockTitle
    description
    illustrationItems {
        
            __typename
            ... on illustrationItem2_Entry {
                image: illustrationImage {
                    url
                    w1212: url @transform(format: "webp", width: 1212)
                    w606: url @transform(width: 606, format: "webp")
                    #w606_avif: url @transform(width: 606, format: "avif")
                    w328: url @transform(width: 328, format: "webp")
                    #w328_avif: url @transform(width: 328, format: "avif")
                }
                title: itemTitle
                description
                sticker
                linkField {
                    ...CraftLinkField
                }
            }
        
    }
}
